import { render, staticRenderFns } from "./JensenInequalityViz.vue?vue&type=template&id=32be4c1a&scoped=true"
import script from "./JensenInequalityViz.vue?vue&type=script&lang=js"
export * from "./JensenInequalityViz.vue?vue&type=script&lang=js"
import style0 from "./JensenInequalityViz.vue?vue&type=style&index=0&id=32be4c1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32be4c1a",
  null
  
)

export default component.exports